import { reduxForm, change } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import AddingLinkModal from './AddingLinkModal'
import { modal } from 'store/entities/modal/actions'
import { getShortenUrl } from 'store/request'

const formProps = {
  form: 'addingLinkForm',
  onSubmit: async (values, dispatch, { textareaRef, formName, field }) => {
    const url = values.get('url')
    const textareaValue = textareaRef.value
    const { selectionStart, selectionEnd } = textareaRef
    try {
      const shortLinkObject = await getShortenUrl(url)
      const link = `<a href="${shortLinkObject.data.url_short}" target="${
        values.get('isOpenInNewTab') ? '_blank' : '_self'
      }">${values.get('text')}</a>`
      const newString = textareaValue.slice(0, selectionStart) + link + textareaValue.slice(selectionEnd)
      dispatch(change(formName, field, newString))
      dispatch(modal.hide())
    } catch (e) {
      console.log('Error while shorten url ', e)
      return url
    }
  },
}

export default reduxForm(formProps)(withTranslation('user')(AddingLinkModal))
